/**
 * components/cardeditor/Toolbar.jsx — editor toolbar.
 *
 * Chunk 3 (Apr 24 2026).
 *
 * Save / Undo / Redo / Reset to preset / Close.
 */

export function Toolbar({ editor, saving, onSave, onReset, onClose, canReset }) {
  const { canUndo, canRedo, undo, redo, dirty } = editor;

  return (
    <div
      className="card-editor-toolbar"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 'var(--sp-3) var(--sp-4)',
        borderBottom: '1px solid var(--line-soft)',
        gap: 'var(--sp-3)',
        flexWrap: 'wrap',
      }}
    >
      <div style={{ display: 'flex', gap: 'var(--sp-2)', alignItems: 'center' }}>
        <button
          type="button"
          className="btn btn-ghost"
          onClick={undo}
          disabled={!canUndo}
          title="Undo (Cmd/Ctrl+Z)"
          style={{ fontSize: 'var(--fs-sm)' }}
        >
          Undo
        </button>
        <button
          type="button"
          className="btn btn-ghost"
          onClick={redo}
          disabled={!canRedo}
          title="Redo (Cmd/Ctrl+Shift+Z)"
          style={{ fontSize: 'var(--fs-sm)' }}
        >
          Redo
        </button>
        {canReset && (
          <button
            type="button"
            className="btn btn-ghost"
            onClick={onReset}
            title="Discard custom layout and revert to the template preset"
            style={{ fontSize: 'var(--fs-sm)', color: '#b42318' }}
          >
            Reset to preset
          </button>
        )}
      </div>

      <div style={{ display: 'flex', gap: 'var(--sp-2)', alignItems: 'center' }}>
        {dirty && (
          <span className="muted" style={{ fontSize: 'var(--fs-xs)' }}>
            Unsaved changes
          </span>
        )}
        <button
          type="button"
          className="btn btn-ghost"
          onClick={onClose}
          style={{ fontSize: 'var(--fs-sm)' }}
        >
          Close
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={onSave}
          disabled={saving || !dirty}
          aria-busy={saving}
          style={{ fontSize: 'var(--fs-sm)' }}
        >
          {saving ? 'Saving…' : 'Save layout'}
        </button>
      </div>
    </div>
  );
}
